export default __webpack_public_path__ + "assets/images/d1fec126f6dcfa209f8a2f552dccec43.svg";